import { AxiosResponse } from 'axios';

import { baseApi } from '../../services/ApiController';
import logger from '../../services/logger/LlsLogger';

export interface CropData {
  toCropImgW?: number;
  toCropImgH?: number;
  toCropImgX: number;
  toCropImgY: number;
}

export interface ImageResponse {
  uuid: string;
  imageUrl: string;
}

export function sendImageToBackend(
  image: string | ArrayBuffer | null,
  url: string,
  crops: CropData,
  callback: (response: AxiosResponse<any> | string) => void,
) {
  const data = new FormData();
  if (image && typeof image === 'string') {
    const blob = b64toBlob(image.split('base64,')[1]);
    data.append('image', blob);
    data.append('toCropImgW', crops.toCropImgW ? crops.toCropImgW.toString() : '0');
    data.append('toCropImgH', crops.toCropImgH ? crops.toCropImgH.toString() : '0');
    data.append('toCropImgX', crops.toCropImgX ? crops.toCropImgX.toString() : '0');
    data.append('toCropImgY', crops.toCropImgY ? crops.toCropImgY.toString() : '0');
    data.append('_jwt', localStorage.jwt);
    data.append('_method', 'PUT');
    baseApi
      .post(url, data)
      .then(response => {
        callback(response);
      })
      .catch(error => {
        logger.info('Error on sending Image', {
          error,
          info: {
            componentStack: 'imageUploader.ts',
          },
        });
        callback('error');
      });
  }
}
// converting a base64 encoded string to a blob
// https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512): Blob => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};
